import { useEffect, useRef } from 'react';

/**
 * Sets `document.title` whenever `title` is non-null.
 * Restores the original title on unmount so navigation away does not
 * leave a stale PDF filename in the browser tab.
 */
export function usePdfDocumentTitle(title: string | null): void {
  const originalTitle = useRef<string | null>(null);

  // Capture and restore only on the client — `document` is unavailable during SSR.
  useEffect(() => {
    originalTitle.current = document.title;

    return () => {
      if (originalTitle.current !== null) {
        document.title = originalTitle.current;
      }
    };
  }, []);

  // Update whenever `title` changes.
  useEffect(() => {
    if (title !== null) {
      document.title = title;
    }
  }, [title]);
}
